/**
 * 多語言 Meta 標籤配置
 * 用於 SEO 和多語言支持
 */

export interface MetaConfig {
  title: string
  description: string
}

export interface LocaleMetaConfig {
  en: MetaConfig
  zh: MetaConfig
  ja: MetaConfig
}

/**
 * 各語言的 Meta 標籤內容
 */
export const metaConfig: LocaleMetaConfig = {
  en: {
    title: 'Bentana - Premier Market Maker on Polymarket | Seed+ Round',
    description:
      'Bentana is the leading liquidity provider and market maker for Polymarket, providing real-time analytics and deep liquidity for decentralized prediction markets.'
  },
  zh: {
    title: 'Bentana - Polymarket 最大做市商 | Seed+ 轮融资中',
    description:
      'Bentana 为去中心化预测市场提供深度流动性与实时数据分析。Polymarket 生态首选做市商，Seed+ 轮融资开放中。'
  },
  ja: {
    title: 'Bentana - Polymarket 最大のマーケットメーカー | シードプラスラウンド',
    description:
      'BentanaはPolymarketの主要な流動性プロバイダーです。分散型予測市場向けのリアルタイム分析と深い流動性を提供します。'
  }
}

/**
 * 支持的語言代碼對應 hreflang
 */
export const localeToHreflang: Record<string, string> = {
  en: 'en',
  zh: 'zh-Hans',
  ja: 'ja'
}

/**
 * 獲取指定語言的 Meta 配置
 * @param locale - 語言代碼 (en, zh, ja)
 * @returns Meta 配置
 */
export function getMetaForLocale(locale: string): MetaConfig {
  // 默認使用英文
  const normalizedLocale = locale.toLowerCase().split('-')[0]
  return metaConfig[normalizedLocale as keyof LocaleMetaConfig] || metaConfig.en
}

/**
 * 生產環境域名
 */
export const PRODUCTION_DOMAIN = 'https://bentana.app'

